import { BaseSelectionManager } from "./shared/BaseSelectionManager.js";

export default function objectItemsData() {
  const isPresent = document.querySelector(".select-item-button");
  if (!isPresent) {
    return;
  }

  return new BaseSelectionManager({
    type: "item",
    buttonSelector: ".select-item-button",
    itemSelector: ".single-interior-item",
    containerSelector: "[data-list-item-selected-items]",
    clearButtonSelector: "[data-clear-choices]",
    confirmButtonSelector: "[data-confirm-interior]",
    changeButtonSelector: "[data-change-interior]",
    frontButtonSelector: "[data-front-select-interior]",
    priceAttribute: "data-interior-item-price",
    confirmationClass: "interior-confirmed",
    dataAttributes: {
      clearCatAttribute: "data-interior-cat-in-list",
      clearCatTitleAttribute: "data-interior-cat-in-list-title",
    },
    messages: {
      userDisabled: "Muudatuste tegemine pole lubatud",
      selected: "Valitud",
      select: "Vali",
      confirmed: "Siseviimistlus kinnitatud",
      confirm: "Kinnita siseviimistlus",
      frontSelect: "Siseviimistlust kinnitama",
    },
  });
}
